import Resource from '@/plugins/sdk/Resource'
import { STRING, BOOLEAN } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'permission'

  static get fields () {
    return {
      resource: new STRING(),
      create: new BOOLEAN(false),
      read: new BOOLEAN(false),
      update: new BOOLEAN(false),
      delete: new BOOLEAN(false),
      restore: new BOOLEAN(false)
    }
  }
}
